export default function GraphLoading() {
  return (
    <div className="w-full flex justify-center h-[300px] items-center">
      <img src="/imgs/loading.gif" alt="Cargando" className="w-[15%]" />
    </div>
  );
}
